import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem("dp_lang") || "it";
  });

  useEffect(() => {
    localStorage.setItem("dp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => setLangState(l === "en" ? "en" : "it");

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "it", setLang: () => {} };
  return ctx;
}

// Helper: pick localized value. Usage: L(lang, "Ciao", "Hello")
export function L(lang, it, en) {
  return lang === "en" ? en : it;
}

// Translate common enum-like car spec values (IT source) to EN
const ENUM_MAP = {
  benzina: "Petrol",
  diesel: "Diesel",
  ibrida: "Hybrid",
  "ibrida plug-in": "Plug-in Hybrid",
  elettrica: "Electric",
  gpl: "LPG",
  metano: "CNG",
  manuale: "Manual",
  automatico: "Automatic",
  sequenziale: "Sequential",
  anteriore: "Front",
  posteriore: "Rear",
  integrale: "All-wheel drive",
};

export function localizeEnum(lang, value) {
  if (lang !== "en" || !value) return value;
  const key = String(value).trim().toLowerCase();
  return ENUM_MAP[key] || value;
}
